import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useCookies } from 'react-cookie';
import { Modal } from 'react-bootstrap';
import { ConfirmDialog } from "primereact/confirmdialog";
import http from '../../../Common/http-common';
import * as common from '../../../Common/common';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Button } from 'primereact/button';

const AllowanceRateDelete = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const acceptLabel = (
      <div style={{ color: 'white' }}>
        <FontAwesomeIcon icon={faCheck} />&nbsp; Yes
      </div>
    );
  
    const rejectLabel = (
      <div>
        <FontAwesomeIcon icon={faXmark} />&nbsp; No
      </div>
    );

  useEffect(() => {
    if (props.editData) {
      setConfirmDelete(true);
    }
  }, [props.editData]);

  const handleCancel = () => {
    setConfirmDelete(false);
    props.onHide();
  };

  const RemoveAllowanceRate = (_data) => {
    let functionName = "";
    try {
      functionName = props.page + RemoveAllowanceRate.name;
      props.onLoading(true, "Deleting Allowance Rate, Please wait....");
      setConfirmDelete(false);

      const data = {
        ALLOWANCE_RATE_MST_ID: _data.ALLOWANCE_RATE_MST_ID,
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
      };

      http
        .post("api/allowancerate/DeleteAllowanceRate", data, { timeout: 5000 })
        .then(() => {
          toast.success("Allowance Rate is successfully deleted.");
          props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to delete allowance rate. Please try again. (send)");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading....");
        });
    } catch (err) {
      props.onLoading(false, "Loading....");
      toast.error("Failed to delete allowance rate. Please try again. (received)");
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <ConfirmDialog
        visible={confirmDelete}
        onHide={handleCancel}
        content={({ headerRef, contentRef, footerRef, hide }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '2rem',
              backgroundColor: '#fff',
              borderRadius: '12px',
              boxShadow: '0 0 10px rgba(0,0,0,0.15)',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: '#d40b0b',
                color: 'white',
                width: '106px',
                height: '106px',
                borderRadius: '50%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '-78px',
                fontSize: '3rem',
              }}
            >
              <i className="pi pi-exclamation-triangle" style={{ fontSize: '2.5rem' }} />
            </div>
        
            <div ref={headerRef} style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '1rem' }}>
              Confirmation
            </div>
            <p ref={contentRef} style={{ marginTop: '1rem', fontSize: '1rem' }}>
              Are you sure you want to delete this allowance rate?
            </p>
            <div ref={footerRef} style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
              <Button
                label={rejectLabel}
                outlined
                style={{ width: '6rem' }}
                onClick={(e) => {
                  hide(e);
                  handleCancel();
                }}
              />
              <Button
                label={acceptLabel}
                className="p-button-danger"
                style={{ border: 'none', width: '6rem' }}
                onClick={(e) => {
                  hide(e);
                  RemoveAllowanceRate(props.editData);
                }}
              />
            </div>
          </div>
        )}
        className="custom-confirm-dialog"
      />
    </>
  );
};

export default AllowanceRateDelete;
